import { render, staticRenderFns } from "./HappyEmoji.vue?vue&type=template&id=375034b8"
import script from "./HappyEmoji.vue?vue&type=script&lang=js"
export * from "./HappyEmoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports